module.exports = __webpack_public_path__ + "img/V-R-3-load-connect-shadow.6c031155.png";